export { default } from "./ChartComparisonContainer";
